import { HELP_HASH_TARGETS } from 'mk2/apps/faq/containers/HelpRedirect/HelpRedirect.constants';
import { faqRootUrl } from 'mk2/apps/faq/urls';
import React from 'react';
import { Props } from './HelpRedirectPage';

//
// this page redirects old-style /help/#hash links to their correspoding equivalents
// in the new FAQ (/faq/article/#optional-hash)
//

class HelpRedirect extends React.Component<Props> {

    public componentDidMount() {
        this.redirectByHash();
    }

    public componentDidUpdate(prevProps: Props) {
        this.redirectByHash();
    }

    public render() {
        return null;
    }

    private redirectByHash() {
        const { location } = this.props;
        const hash = location.hash ? location.hash.slice(1) : '';
        const targetUrl = HELP_HASH_TARGETS[hash] || faqRootUrl;
        const [targetPath, targetHash] = targetUrl.split('#');
        this.props.history.replace({ pathname: targetPath, hash: targetHash });
    }
}

export default HelpRedirect;
